var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15078 0.449219C10.6361 0.449219 12.6508 2.46394 12.6508 4.94922V11.9492C12.6508 14.4345 10.6361 16.4492 8.15078 16.4492C5.6655 16.4492 3.65078 14.4345 3.65078 11.9492V4.94922C3.65078 2.46394 5.6655 0.449219 8.15078 0.449219ZM0.900781 10.7776C1.19902 10.7776 1.44643 10.9952 1.49293 11.2803L1.50078 11.3776V11.5095C1.50078 15.2496 4.48028 18.2776 8.15078 18.2776C11.7432 18.2776 14.6737 15.3771 14.7968 11.7473L14.8008 11.5095V11.388C14.8008 11.0566 15.0694 10.788 15.4008 10.788C15.699 10.788 15.9464 11.0056 15.9929 11.2907L16.0008 11.388L15.997 11.7576C15.8741 15.8383 12.7274 19.1498 8.75065 19.4547L8.75078 22.9492C8.75078 23.2806 8.48215 23.5492 8.15078 23.5492C7.85255 23.5492 7.60513 23.3316 7.55863 23.0465L7.55078 22.9492L7.55125 19.4547C3.57687 19.1501 0.431479 15.8426 0.304751 11.7653L0.300781 11.3776C0.300781 11.0462 0.56941 10.7776 0.900781 10.7776ZM4.85078 4.94922C4.85078 3.12668 6.32824 1.64922 8.15078 1.64922C9.97332 1.64922 11.4508 3.12668 11.4508 4.94922V11.9492C11.4508 13.7718 9.97332 15.2492 8.15078 15.2492C6.32824 15.2492 4.85078 13.7718 4.85078 11.9492V4.94922Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordAudio);
export default __webpack_public_path__ + "static/media/Record Audio.938e068d691f3d813c72d030ddc88bd2.svg";
export { ForwardRef as ReactComponent };